<template>
  <CreditPackagePurchase
    :scope="props.scope"
    :tenant="props.tenant"
    :packages="props.packages"
    :model-value="props.selectedPackage"
    @update:model-value="emits('change', $event)"
    @update:coupon-code="emits('couponChange', $event)"
    @update:coupon-dirty="emits('couponDirtyChange', $event)"
  />
</template>

<script setup lang="ts">
const props = defineProps<{
  selectedPackage: any | null;
  scope?: "personal" | "organization";
  tenant?: string;
  packages?: any[];
}>();

const emits = defineEmits<{
  (event: "change", value: any): void;
  (event: "couponChange", value: string): void;
  (event: "couponDirtyChange", value: boolean): void;
}>();
</script>
